module.exports = function() {
  return new Worker(__webpack_public_path__ + "d853673df5904919047a.worker.js");
};